var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50008 12.6667L9.50008 9.50004M9.50008 6.33337H9.49216M1.58342 9.50004C1.58342 13.8723 5.12783 17.4167 9.50008 17.4167C13.8723 17.4167 17.4167 13.8723 17.4167 9.50004C17.4167 5.12779 13.8723 1.58337 9.50008 1.58337C5.12783 1.58337 1.58342 5.12779 1.58342 9.50004Z",
    stroke: "#5B6C7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.adf0233118172869c3d0a599b49597cd.svg";
export { ForwardRef as ReactComponent };